import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/page.js"
import { Button } from 'module-tsl-ui-elements';
import { Modal, EnhancedModal } from 'module-tsl-ui-modal';
import ModalWithDocgen from 'module-tsl-ui-modal/with-docs/Modal';
import pkg from 'module-tsl-ui-modal/package.json';
import PropsTable from '../../../components/propsTable';
import Version from '../../../components/version';
import LiveCode from '../../../components/liveCode';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>


<MDXTag name="h3" components={components} props={{"id":"examples-editable"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#examples-editable","aria-label":"examples editable permalink","class":"anchor"}}></MDXTag>{`examples (editable)`}</MDXTag>
<LiveCode
  code={`class ModalToggle extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
  }
  render() {
    return (
      <div>
        <Button onClick={() => this.setState({ open: true })}>open modal</Button>
        <Modal
          showModal={this.state.open}
          onHideModal={() => this.setState({ open: false })}
        >
          <span>Hello world!</span>
        </Modal>
      </div>
    )
  }
}
`}
  scope={ { Modal, Button } }
/>
<MDXTag name="h3" components={components} props={{"id":"Enhanced-Modal-example-editable"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#Enhanced-Modal-example-editable","aria-label":"Enhanced Modal example editable permalink","class":"anchor"}}></MDXTag>{`Enhanced Modal example (editable)`}</MDXTag>
<LiveCode
  code={`class ModalToggle extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
  }
  render() {
    return (
      <div>
        <Button onClick={() => this.setState({ open: true })}>open enhanced modal</Button>
        <EnhancedModal
          showModal={this.state.open}
          onHideModal={() => this.setState({ open: false })}
          title="Title"
          subtitle="Subtitle"
          icon="tds-bookmark"
          buttons={[<Button>OK</Button>, <Button>Cancel</Button>]}
        >
          <span>Hello world!</span>
        </EnhancedModal>
      </div>
    )
  }
}
`}
  scope={ { EnhancedModal, Button } }
/>
<PropsTable data={ModalWithDocgen.__docgenInfo} />
<Version name={'npm i module-tsl-ui-modal --save'} version={pkg.version} />
           </MDXTag>
  }
}

export const _frontmatter = {};

  